import React from 'react'

const Layout = ({ children }: { children: React.ReactNode }) => {
    return (
        // dùng tailwind css để tạo layout
        <div className='flex flex-col h-screen'>
            <div className='flex-1'>
                {children}
            </div>
        </div>
    )
}

export default Layout